var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMobileDetection } from 'vue3-mobile-detection';
import { DROPDOWN_CLASSES, getOverlayClasses, getListContainerClasses, LIST_CLASSES, OPTION_CHECK_ICON_CLASSES, OPTION_BLANK_ICON_CLASSES, EMPTY_MESSAGE_CLASSES, PC_FILTER_CONTAINER, PC_FILTER, PC_FILTER_ICON_CONTAINER, TRANSITION_CLASSES, OPTION_GROUP_CLASSES, getOptionClasses, getRootClasses, getHeaderClasses, } from 'common/vue/PrimeVueConfig/Constants/select';
var isMobile = useMobileDetection().isMobile;
export default {
    root: function (_a) {
        var props = _a.props, state = _a.state;
        return (__assign({}, getRootClasses(props, state)));
    },
    label: function (_a) {
        var _b;
        var props = _a.props, parent = _a.parent;
        return ({
            class: [
                // Font
                'tw-leading-5',
                'tw-text-md',
                // Display
                'tw-block',
                'tw-flex-auto',
                // Color and Background
                'tw-bg-transparent',
                'tw-border-0',
                {
                    'tw-text-gray-800 dark:tw-text-white/80': props.modelValue != undefined,
                    'tw-text-gray-400 dark:tw-text-gray-500': props.modelValue == undefined,
                },
                'placeholder:tw-text-gray-400 dark:placeholder:tw-text-gray-500',
                // Sizing and Spacing
                'tw-w-[1%]',
                'tw-px-2.5 tw-py-1',
                // Shape
                'tw-rounded-none',
                // Transitions
                'tw-transition',
                'tw-duration-200',
                // States
                'focus:tw-outline-none focus:tw-shadow-none',
                // Filled State for FloatLabel
                { filled: ((_b = parent.instance) === null || _b === void 0 ? void 0 : _b.$name) === 'FloatLabel' && props.modelValue !== null },
                // Misc
                'tw-relative',
                'tw-cursor-pointer',
                'tw-overflow-hidden tw-overflow-ellipsis',
                'tw-whitespace-nowrap',
                'tw-appearance-none',
            ],
        });
    },
    dropdown: {
        class: DROPDOWN_CLASSES,
    },
    overlay: __assign({}, getOverlayClasses(isMobile())),
    listContainer: function (_a) {
        var props = _a.props;
        return (__assign({}, getListContainerClasses(isMobile(), Boolean(props.filter))));
    },
    list: {
        class: LIST_CLASSES,
    },
    option: function (_a) {
        var context = _a.context;
        return ({
            class: __spreadArray(__spreadArray([], __read(getOptionClasses(context)), false), [
                'tw-py-2 tw-px-3',
                {
                    'tw-bg-primary-500 tw-text-white': context.selected,
                    'tw-text-gray-700 dark:tw-text-white/80': !context.focused && !context.selected,
                    'tw-bg-gray-200 dark:tw-bg-gray-600/60': context.focused && !context.selected,
                    'hover:tw-bg-gray-100 dark:hover:tw-bg-gray-600/80': !context.focused && !context.selected,
                },
                'focus-visible:tw-outline-none focus-visible:tw-outline-offset-0 focus-visible:tw-ring focus-visible:tw-ring-inset',
                'focus-visible:tw-ring-primary-400/50 dark:focus-visible:tw-ring-primary-300/50',
            ], false),
        });
    },
    optionGroup: {
        class: OPTION_GROUP_CLASSES,
    },
    optionCheckIcon: OPTION_CHECK_ICON_CLASSES,
    optionBlankIcon: OPTION_BLANK_ICON_CLASSES,
    emptyMessage: {
        class: EMPTY_MESSAGE_CLASSES,
    },
    header: function (_a) {
        var props = _a.props;
        return ({
            class: __spreadArray([], __read(getHeaderClasses(isMobile(), props)), false),
        });
    },
    // clearIcon and loadingIcon remain commented out as before
    pcFilterContainer: PC_FILTER_CONTAINER,
    pcFilter: PC_FILTER,
    pcFilterIconContainer: PC_FILTER_ICON_CONTAINER,
    transition: TRANSITION_CLASSES,
};
